module.exports = __webpack_public_path__ + "img/page.79a9655d.png";